require('C:\\OpenServer540\\domains\\projektai-lsd\\Project\\assets\\js\\shared.js')